

















































































































































import { Component, Vue, Provide, Prop } from "vue-property-decorator";
@Component({
  name: "ApproveRepaymentPlan",
  components: {
    MaskComponent: () => import("@/components/MaskComponent.vue")
  }
})
export default class Approve extends Vue {
  @Prop() repaymentPlanData: any;
  @Prop() repayplanstageList: any;
  @Provide() group: any = [];
  @Provide() groupList: any = [];

  private created() {
    this.dwTableList(this.repaymentPlanData, this.group);
    this.dwTableList(this.repayplanstageList, this.groupList);
  }
  private dwTableList(data: any, list: any) {
    if (data.group && data.group.length > 0) {
      // data.group.forEach((item: any, index: number) => {
      //   if (index % 2 === 0) {
      //     let groupItem: any = [item];
      //     list.push(groupItem);
      //   } else {
      //     list[list.length - 1].push(item);
      //   }
      // })
      list = data.group;
    }
  }
  private hideMask() {
    this.$emit("hideRepaymentDialog", {
      hidden: true,
      val: null
    });
  }
}
